import { Skeleton } from '@/ui/components/skeleton/skeleton';

export function MetricsLoading() {
  return (
    <div className="space-y-6 rounded-lg border-2 border-gray-200 bg-gray-50 p-6">
      {/* Header section skeleton */}
      <div>
        <Skeleton className="h-7 w-80" />
        <Skeleton className="mt-1 h-4 w-64" />
        <div className="mt-2">
          <Skeleton className="h-3 w-48" />
        </div>
      </div>

      {/* Metrics groups grid skeleton */}
      <div className="grid w-full auto-cols-fr grid-flow-col gap-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <div
            key={i}
            className="rounded-lg border border-gray-200 bg-white p-4"
          >
            {/* Metric items skeleton */}
            <div className="space-y-3">
              {Array.from({ length: 1 }).map((_, j) => (
                <div key={j} className="space-y-1">
                  <Skeleton className="h-6 w-16" />
                  <Skeleton className="h-4 w-20" />
                </div>
              ))}
            </div>

            {/* Footer section skeleton */}
            <div className="mt-6 flex items-center justify-between border-t border-gray-100 pt-2">
              <div></div>
              <Skeleton className="size-6" />
            </div>
          </div>
        ))}
      </div>

      {/* Chart skeleton */}
      <div className="h-[436px] rounded-lg border border-gray-200 bg-white p-4"></div>
    </div>
  );
}
